export default {
  tenantContextDocumentCount(state: any): number {
    if (state.tenantContextDocumentsPagination && typeof state.tenantContextDocumentsPagination.totalRows === 'number') {
      return state.tenantContextDocumentsPagination.totalRows
    }

    return state.tenantContextDocuments.length
  },
  tenantContextPagination(state: any): any {
    return state.tenantContextDocumentsPagination
  },
}
